import React, { FunctionComponent, useContext } from 'react'
import styles from './ProjectFiltersMobile.module.sass'
import Field from '../../../../../controls/Field/Field'
import { useBoolean } from '../../../../../../utils/hooks'
import SearchIcon from 'files/search.svg'
import { identity } from 'fp-ts/es6/function'
import { projectStatusToColor, projectStatusToName } from '../../../../../../responses/projects'
import { statusToggle } from '../ProjectFiltersDesktop/ProjectFiltersDesktop'
import Popover from '../../../../../etc/Popover'
import DropdownElement from '../../../../../data-components/dropdowns/DropdownElement/DropdownElement'
import List from '../../../../../data-components/lists/List/List'
import { Checkbox } from '../../../../../controls/Checkbox/Checkbox'
import { elem } from 'fp-ts/Array'
import { eqNumber } from 'fp-ts/Eq'
import ShadowContainer from '../../../../../etc/popover/ShadowContainer/ShadowContainer'
import { Classes } from '../../../../../../styles'
import { RequestStatus } from '../../../../../../responses/response'
import { statusContext } from '../../../../../../constants/contexts'
import { ProjectFiltersProps } from '../props'

const ProjectFiltersMobile: FunctionComponent<ProjectFiltersProps> = props => {
    const {search, projectStatus} = props.value
    const {state: open, setFalse, toggle} = useBoolean()
    const status = useContext(statusContext)

    return <div className={styles.filters}>
        <div className={styles.dropdown}>
            <div className={styles.projects}>
                Показано проектов:
                <span className={Classes.cDark}>
                    {status === RequestStatus.FETCHING && props.total === 0? '...': props.total}
                </span>
            </div>
            <Popover
                reposition={false}
                padding={0}
                isOpen={open}
                positions={['bottom']}
                onClickOutside={setFalse}
                content={<ShadowContainer>
                    <List
                        data={props.statusFilters}
                        toKey={identity}
                        render={status => <Checkbox
                            value={elem(eqNumber)(status, projectStatus)}
                            color={projectStatusToColor(status)}
                            onChange={() => props.onChange({projectStatus: statusToggle(status)(projectStatus)})}
                        >
                            {projectStatusToName(status)}
                        </Checkbox>}
                    />
                </ShadowContainer>}
            >
                <DropdownElement borderless active={open} onToggle={toggle}>
                    <span className={styles.text}>Проекты</span>
                </DropdownElement>
            </Popover>
        </div>
        <Field
            className={styles.field}
            value={search}
            placeholder={'Поиск проекта'}
            rightItem={<SearchIcon/>}
            type={'text'}
            onChange={search => props.onChange({search})}
        />
    </div>
}

export default ProjectFiltersMobile